import { render, staticRenderFns } from "./SuaUsina.vue?vue&type=template&id=0ffa3a04&scoped=true&"
import script from "./SuaUsina.vue?vue&type=script&lang=js&"
export * from "./SuaUsina.vue?vue&type=script&lang=js&"
import style0 from "./SuaUsina.vue?vue&type=style&index=0&id=0ffa3a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa3a04",
  null
  
)

export default component.exports